module.exports = __webpack_public_path__ + "static/media/ReportEstrellasDerecha.3cb3e828.png";